import TomSelect from "tom-select";
const teamMemberTabs = document.querySelectorAll('.team-members .nav-item .nav-link');
if(teamMemberTabs) {
	teamMemberTabs.forEach(teamMemberTab => {
		teamMemberTab.addEventListener('shown.bs.tab', event => {
			const activeTab = event.target as HTMLElement;
      const activeTabId = activeTab.getAttribute('data-bs-target');
      const value = activeTabId?.replace('#tab-modul-', '');
			// Update the selected value of the Tom Select dropdown
			const customSelect = document.querySelector('#custom-select-team-members') as HTMLSelectElement;
			// Update the selected value of the Tom Select dropdown
    });
	});
	
}
const customSelect = document.querySelector('#custom-select-team-members') as HTMLSelectElement;
if(customSelect) {
	const tabSelectpicker = new TomSelect(`#${customSelect.id}`,{
		onChange: function(value: string) {
			const currentTab = document.querySelector('.tab-team-members .tab-pane.show.active');
      const tabs = document.querySelector('.nav-tabs.team-members');
      const activeTab = document.querySelector('.nav-tabs .active');
      //
      tabs?.querySelector(`[data-bs-target="#tab-modul-${value}"]`)?.classList.add('active');
      activeTab?.classList.remove('active');
      currentTab?.classList.remove('show', 'active');
			
			setTimeout(() => {
				const activeTab = document.getElementById(`tab-modul-${value}`);
				activeTab?.classList.add('show', 'active');
			}, 200);
		},
	});
	window.addEventListener('resize', function() {

		if(window.innerWidth === 1200) {
			
			const activeTab = document.querySelector('.tab-pane.show.active');
			const activeTabId = activeTab?.getAttribute('id');
			const value = activeTabId?.replace('tab-modul-', ''); // Update the selected value of the Tom Select dropdown
			if(value) {
				
				tabSelectpicker.setValue(value);
			}
		}
		else {
			const tabSelectValue = tabSelectpicker.getValue();
			this.document.querySelector(`[data-bs-target="#tab-modul-${tabSelectValue}"]`)?.classList.add('active');

		}
		
	});
}
const downloadTabs = document.querySelectorAll('.download-mediathek .nav-item .nav-link');

if (downloadTabs) {
  downloadTabs.forEach(downloadTab => {
    downloadTab.addEventListener('shown.bs.tab', event => {
			const activeTab = event.target as HTMLElement;
      const activeTabId = activeTab.getAttribute('data-bs-target');
      const value = activeTabId?.replace('#tab-modul-', '');
     
    });
  });
}

const customSelectDownloads = document.querySelector('#custom-select-downloads') as HTMLSelectElement;
const activeSelectpicker = document.querySelector('.nice-select') as HTMLElement;

if (customSelectDownloads) {
  const tabSelectpicker = new TomSelect(`#${customSelectDownloads.id}`, {
		
    onChange: function(value: string) {
      const currentTab = document.querySelector('.tab-downloads .tab-pane.show.active');
      const tabs = currentTab?.closest('.tabs')?.querySelector('.nav-tabs');
      const activeTab = currentTab?.closest('.tabs')?.querySelector('.nav-tabs .active');
      //
      tabs?.querySelector(`[data-bs-target="#tab-modul-${value}"]`)?.classList.add('active');
      activeTab?.classList.remove('active');
      currentTab?.classList.remove('show', 'active');
			
      setTimeout(() => {
        const activeTab = document.getElementById(`tab-modul-${value}`);
        activeTab?.classList.add('show', 'active');
      }, 200);
    }
		
  });
	window.addEventListener('resize', function() {

		if(window.innerWidth === 1200) {
			
			const activeTab = document.querySelector('.tab-pane.show.active');
			const activeTabId = activeTab?.getAttribute('id');
			const value = activeTabId?.replace('tab-modul-', ''); // Update the selected value of the Tom Select dropdown
			if(value) {
				
				tabSelectpicker.setValue(value);
			}
		}
		else {
			const tabSelectValue = tabSelectpicker.getValue();
			this.document.querySelector(`[data-bs-target="#tab-modul-${tabSelectValue}"]`)?.classList.add('active');

		}
		
	});
}
